var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.timeItems),function(item){return _c('time-item',{key:item.en,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }